import { render, staticRenderFns } from "./SharesOperationsDetailsTable.vue?vue&type=template&id=156f06ea&scoped=true&"
import script from "./SharesOperationsDetailsTable.vue?vue&type=script&lang=js&"
export * from "./SharesOperationsDetailsTable.vue?vue&type=script&lang=js&"
import style0 from "./SharesOperationsDetailsTable.vue?vue&type=style&index=0&id=156f06ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156f06ea",
  null
  
)

export default component.exports